document.querySelectorAll('slider-component.image-video-slider').forEach((slider) => {
  if (slider.dataset.autoplay === 'true') {
    const speed = parseInt(slider.dataset.autoplaySpeed, 10) || 5000;
    const nextButton = slider.querySelector('button[name="next"]');
    if (nextButton) {
      let timer = setInterval(() => nextButton.click(), speed);
      slider.addEventListener('mouseenter', () => clearInterval(timer));
      slider.addEventListener('mouseleave', () => {
        timer = setInterval(() => nextButton.click(), speed);
      });
    }
  }

  slider.querySelectorAll('.image-video-slider__video-slide').forEach((wrapper) => {
    const video = wrapper.querySelector('video');
    if (!video) return;

    wrapper.addEventListener('click', () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', () => wrapper.classList.add('playing'));
    video.addEventListener('pause', () => wrapper.classList.remove('playing'));

    if (video.readyState >= 2) {
      wrapper.classList.add('media-ready');
    } else {
      video.addEventListener('loadeddata', () => wrapper.classList.add('media-ready'), { once: true });
    }
  });
});
